<script>
    import {OBJECTS} from "../../lib/constants";
    import ColoredNameControl from "../controls/ColoredNameControl.svelte";
    import ColoredAcronym from "../controls/ColoredAcronym.svelte";
    import AppIcon from "../icons/AppIcon.svelte";

    export let object = null;

    $: {
        if ((object.object_type == OBJECTS.SERVICE || object.object_type == OBJECTS.SUBSCRIPTION) && !object.ws_service) {
            object.ws_service = {name: '', color: 'CCCCCC'};
        }
        if (!object.name) {
            object.name = '-';
        }
    }
</script>
{#if object}
    {#if object.object_type == OBJECTS.CLIENT}
        <div class="object">
            <AppIcon icon="client" size="12"/>
            { object.name }
        </div>
    {:else if object.object_type == OBJECTS.PROJECT}
        <ColoredNameControl name="{ object.name }" color="{ object.color }" colorName/>
    {:else if object.object_type == OBJECTS.SERVICE}
        <ColoredAcronym name="{ object.name }"
                        acronymName="{ object.ws_service.name }"
                        color="{ object.ws_service.color }"/>
    {:else if object.object_type == OBJECTS.SUBSCRIPTION}
        <ColoredAcronym name="{ object.name }"
                        acronymName="{ object.ws_service.name }"
                        color="{ object.ws_service.color}"/>
    {:else if object.object_type == OBJECTS.TASK}
        <div class="object">
            <AppIcon icon="clock" size="14"/>
            Εργασία
        </div>
    {:else}
        { object.name }
    {/if}
{/if}

<style>
    .object {
        position: relative;
        width: max-content;
        padding-left: 20px;
    }

    :global(.object .app-icon) {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
</style>